import { horizontal, vertical, diagonalDesc, diagonalAsc, GradientDirection } from "@cloudinary/transformation-builder-sdk/qualifiers/gradientDirection";
export { horizontal, vertical, diagonalDesc, diagonalAsc, GradientDirection };
